import type { FaireProductEntity } from "../../entity_types/product";

export const p_x7dcc8fjse: FaireProductEntity = {
  token: "p_x7dcc8fjse",
  type: "product",
  name: "rocky's matcha Sasaki Ceremonial Blend 1kg",
  brandToken: "b_jkddc7grcu",
  brandName: "rocky's matcha",
  imageUrl: "https://cdn.faire.com/fastly/0483e822fdc3f008602dda55b5e09069cc3137460f4abb1a208ccc389eda01c9.jpeg",
  galleryImageUrls: [],
  priceDollars: 375,
  description: "Our Sasaki Ceremonial Matcha is a single-origin tea made exclusively from first flush Sakimidori cultivar leaves grown in the Miyazaki Prefecture. These tea leaves were harvested around mid-May of this year using mechanical picking, and the shading period lasted at least 21 days. \n\nAbout the Sakimidori cultivar, it was originally developed in 1997 in Miyazaki Prefecture. It is characterized by its particularly vivid green color, refreshing aroma, umami, and mellow flavor.\n\nIdeal for usucha (traditional matcha whisked with water). Also works beautifully for lattes, it’s high-quality enough to shine entirely on its own.\n\n+ Single Cultivar Matcha\n\n+ Ceremonial Grade\n\n+ Region: Miyazaki, Japan\n\n+ Net Weight: 1kg\n",
  tags: [],
  msrpDollars: 750,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:21.418Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
